import FlightSearchApi from "@/services/FlightSearchApi";
import store from "../store";

export default {
  getBookingDetails(params) {
    if (store.state.loading !== true) {
      store.commit("setLoading", true);
      return FlightSearchApi()
        .post("", params)
        .then(function(response) {
          if (
            typeof response.data === "object" &&
            response.data.error === undefined
          ) {
            store.commit("saveFlightDetails", response.data);
            return true;
          } else {
            if (response.data.error !== undefined) {
              console.log("ERROR: ", response.data.error);
            }
            console.log("INVALID RESULT for getBookingDetails: ", response);
          }
          return false;
        })
        .catch(function(error) {
          console.log("ERROR: ", error);
          store.commit("setErrorState", [
            "Departing",
            "Network Error. Please reload the page and try again."
          ]);
          return false;
        })
        .finally(function() {
          store.commit("setLoading", false);
        });
    }
  }
};
